import styled from '@emotion/styled';

const Grow = styled.div({
  'flexGrow': 1,
  '& time': {
    fontSize: 12,
    fontWeight: 300
  }
});

export default Grow;
